import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { Dialog } from '../../Dialog'

export type ModalInfoProps = {
  isModalOpen: boolean,
  toggleModal: () => void
}

export const InfoModal: React.FC<ModalInfoProps> = (props) => {
  const { isModalOpen, toggleModal } = props

  return (
    <Dialog
      isVisible={isModalOpen}
      onClose={toggleModal}
    >
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 1,
        marginBottom: 3
      }}>
        <Typography variant='airbnbH2' sx={{
          fontWeight: 'bold'
        }}>
          Desculpe.
        </Typography>
        <Typography variant='airbnbBody1' sx={{
          fontWeight: 'bold'
        }}>
          No momento não estamos realizando novos empréstimos para empresas por este canal.
        </Typography>
      </Box>
    </Dialog>
  )
}
